module.exports = __webpack_public_path__ + "img/5.da11956f.jpg";